import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
	apiKey: "AIzaSyB2vWOfE1Mo7ZuUQgh3YT20TtykXqNUHsw",
	authDomain: "buildfaast.firebaseapp.com",
	projectId: "buildfaast",
	storageBucket: "buildfaast.appspot.com",
	messagingSenderId: "349203351339",
	appId: "1:349203351339:web:a6a4a4b9e77a6ee157e76e",
	measurementId: "G-W4YR21NVRG",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);

const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

const db = firebaseApp.firestore();

export { auth, provider, firebaseConfig };
export default db;
